/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, HostListener, Output, VERSION } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { assetsConst } from '../../const/assets.const';
import { ROLE, SideBarConst } from '../../const/sideBarConst';
import { TranslateService } from '@ngx-translate/core';
import { LoginDetails } from 'src/app/models/login';
import { SideBar } from 'src/app/models/sideBar';
import { ModuleConst } from '../../const/moduleConst';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'mega-store-vendor-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  // The collapsed rail sits on the right in Arabic, so its tooltips have to
  // open towards the content instead of off the edge of the screen.
  tooltipPosition: TooltipPosition =
    document.documentElement.dir === 'rtl' ? 'left' : 'right';
  @Output() urlOutput = new EventEmitter<any>();
  assetsConst = assetsConst;
  sideBar = SideBarConst;
  public innerWidth: any;
  panelOpenState = false;
  version = VERSION;
  sidenavWidth = 15;
  ngStyle!: string;
  filteredSideBar: Array<SideBar> = [];

  permissions: any = [];
  role = ROLE;
  constructor(
    public _authService :AuthService,
    public translateService: TranslateService) {
    this._authService.profileDetails.subscribe((res: LoginDetails | null) => {
      if (res) {
        console.log('asdasd', res, this.sideBar);
        if(res.accessRole?.permission?.length > 0) {
          this.permissions = res.accessRole.permission;
        }
        if(res.role === this.role.SUBVENDOR){
          this.sideBar = this.sideBar.filter(item => item.sideBarId !== ModuleConst.SubAdmin && item.sideBarId !== ModuleConst.Settings);
          this.filterSidebarItems();
        } else {
          this.filteredSideBar = this.sideBar;
        }
      }
    });
  }

  filterSidebarItems(): void {
    this.filteredSideBar = this.sideBar.map(item => {
      if (item.sideBarId === ModuleConst.SubAdmin) {
        return null;
      }

      const mainItemPermission = this.permissions.find((permission: any) => 
        permission.sideBarId === item.sideBarId && permission.isView
      );

      if (item.isSubMenu && item.subMenuItems && item.subMenuItems.length > 0) {
        const filteredSubItems = item.subMenuItems.filter(subItem => {
          const subPermission = this.permissions.find((permission: any) => 
            permission.sideBarId === subItem.sideBarId && permission.isView
          );
          return subPermission !== undefined;
        });

        if (mainItemPermission || filteredSubItems.length > 0) {
          return {
            ...item,
            subMenuItems: filteredSubItems
          };
        }
        return null;
      }

      if (mainItemPermission) {
        return item;
      }

      return null;
    }).filter(item => item !== null) as Array<SideBar>;
  }

  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav() :void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 991) {
      this._authService.toggle();
    }
  }

}
